//Valentine's Offer text direct static replacement

(function () {
  var OLD_TEXTS = [
    "🥳 Vores jubilæums-udsalg er live nu! 🥳",
    "🥳 Vores jubilæums-udsalg er live nu! 🥳"
  ];
 // var NEW_TEXT = "❤️ Vores valentinsudsalg er live nu! ❤️";
  //var NEW_TEXT = "Vores påskeudsalg er i gang nu 🐰🐣";
  // var NEW_TEXT = "🕵️ Vores hemmelige majudsalg er nu live! 🕵️";
  var NEW_TEXT = "🤸🎈 Vores Play Days-udsalg er nu i gang 🎈👩🏼‍🤝‍👨🏽";

  function replaceText(root) {
    var scope = root || document;

    scope
      .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSale")
      .forEach(function (el) {
        if (OLD_TEXTS.includes(el.textContent.trim())) {
          el.textContent = NEW_TEXT;
        }
      });
  }

  replaceText();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "childList" || m.type === "characterData") {
          replaceText(m.target.nodeType === 1 ? m.target : m.target.parentNode);
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();





// (function() {

//   // var NEW_HEADING_TEXT = "🎉 Vores Cyber Monday udsalg er skudt i gang! 🥳";
//   // var NEW_HEADING_HTML = '🎉 Vores <span class="black-friday-allproducts">Cyber Monday</span> udsalg er skudt i gang! 🥳';

//   var NEW_HEADING_TEXT = "🥳 Vores Jubilæum udsalg er skudt i gang! 🥳";
//   var NEW_HEADING_HTML = '🥳 Vores <span class="black-friday-allproducts">Jubilæum</span> udsalg er skudt i gang! 🥳';

//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("jubilæumsudsalget er i gang") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("i dag") &&
//         lower.includes("jubilæum") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/fejrer vi vores\s+jubilæum!?/i, "fejrer vi vores Jubilæum-udsalg!");
//         newText = newText.replace(
//           /fejrer vi vores Jubilæum-udsalg!/,
//           'fejrer vi vores <span class="black-friday-allproducts">Jubilæum</span>-udsalg!'
//         );

//         newText = newText.replace(/🎉/g, "🎉").replace(/🥳/g, "🥳");

//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();


// (function() {

//   // var NEW_HEADING_TEXT = "🎉 Vores Cyber Monday udsalg er skudt i gang! 🥳";
//   // var NEW_HEADING_HTML = '🎉 Vores <span class="black-friday-allproducts">Cyber Monday</span> udsalg er skudt i gang! 🥳';

//   var NEW_HEADING_TEXT = "🎄 Vores Jule udsalg er skudt i gang! 🎅";
//   var NEW_HEADING_HTML = '🎄 Vores <span class="black-friday-allproducts">Jule</span> udsalg er skudt i gang! 🎅';

//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("jubilæumsudsalget er i gang") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("i dag") &&
//         lower.includes("jubilæum") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/fejrer vi vores\s+jubilæum!?/i, "fejrer vi vores Jule-udsalg!");
//         newText = newText.replace(
//           /fejrer vi vores Jule-udsalg!/,
//           'fejrer vi vores <span class="black-friday-allproducts">Jule</span>-udsalg!'
//         );

//         newText = newText.replace(/🎉/g, "🎄").replace(/🥳/g, "🎅");

//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();

